import PropTypes from 'prop-types'

import track from '~helpers/track'

/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
const OutboundLink = ({ href, ...rest }) => (
  <a
    data-link-external
    target="_blank"
    rel="noopener noreferrer nofollow"
    href={href}
    onClick={() => {
      track('Click', {
        label: href,
      })
    }}
    {...rest}
  />
)

OutboundLink.propTypes = {
  href: PropTypes.string.isRequired,
}
/* eslint-enable jsx-a11y/anchor-has-content, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */

export default OutboundLink
